<template>
    <div>
    <b-form @submit="saveSwitch">
        <b-tabs vertical pills card content-class="mt-3">
            <b-tab :title="$t('Main')" active>
                <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
                    <b-form-input type="text" disabled v-model="switch_entry.id"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input required type="text" v-model="switch_entry.name"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Actual address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="text" v-model="switch_entry.location"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-input-group>
                  <b-form-input type="text" v-model="switch_entry.house_id" :placeholder="$t('Tap to select')"/>
                  <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
                </b-input-group>
                </b-form-group>
            </b-tab>
            <b-tab  :title="$t('Device parameters')" lazy>
              <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select required :options="switchProfiles" v-model="switch_entry.type"></b-form-select>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Remote ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input required type="text" v-model="switch_entry.remote_id"/>
              </b-form-group>
              <b-form-group label-align="right" required :label="$t('Ports count')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select  :options="portsCountOpt"  v-model="switch_entry.ports_count">
                  <option :value="switch_entry.ports_count"/>
                </b-form-select>
              </b-form-group>
            </b-tab>
            <b-tab lazy :title="$t('Access parameters')">
                <b-form-group label-align="right" :label="$t('IP')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="text" v-model="switch_entry.address"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="text" v-model="switch_entry.login"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="text" v-model="switch_entry.password"/>
                </b-form-group>
            </b-tab>
            <b-tab v-if="isEdit" :title="$t('Ports usage')">
                <b-form-group label-align="right" :label="$t('Used ports')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input disabled type="text" v-model="portUsageLength"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Free ports')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input disabled type="text" v-model="portsUsedVar"/>
                </b-form-group>
                <b-container  class="container">
                  <div v-for="cell in cellsDATA" :key="cell.id" class="cell">
                      <div v-if="cell.isOn">
                        <b-img v-if="JSON.parse(portsUsageMap.get(cell.port)).user_data.length > 1" v-b-tooltip="portsUsageMap.get(cell.port)"
                        :src='editImageEthError'/>
                        <b-img v-else v-b-tooltip="portsUsageMap.get(cell.port)"
                        :src='editImageEthOn'/>
                      </div>
                      <div v-else>
                        <b-img v-b-tooltip.hover="portsUsageMap.get(cell.id)" :src='editImageEthOff'/>
                      </div>
                  </div>
                </b-container>
                  <md-button  v-if="isEnabledIpPortLink"
                    class="md-raised"
                    style="margin: 3% 0% 0% 15%"
                    v-b-toggle.collapse-1
                    size="sm"
                    variant="outline-primary">{{$t('Port-ip link')}}
                  </md-button>
                  <b-collapse id="collapse-1" class="mt-2">
                    <b-card>
                      <b-form-group
                      label-align="right" :label="$t('IPv4 subnet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-input-group>
                            <b-input
                            style="margin-top: 0%"
                            v-model="ipPortSubnet" @change="ipPortSubnetUpdate"></b-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group :key="rerenderPorts"
                      label-align="right" style="width: 90%; margin-top: 35px; margin-left: 35%" >
                        <div v-for="cell in cellsDATA" :key="cell.id">
                          <b-input-group style="margin-top: 2%;" size="sm" >
                            <div>
                              <b-form-checkbox switch style="margin-top:3%; margin-left:-10%" size="sm" v-model="ipPortIpEnable[cell.port]" />
                            </div>
                            <div style="height: 25px; width: 25px;" v-if="cell.isOn">
                              <b-img v-if="JSON.parse(portsUsageMap.get(cell.port)).user_data.length > 1"
                              :src='editImageEthError'/>
                              <b-img v-else
                              :src='editImageEthOn'/>
                            </div>
                            <div v-else style="height: 25px; width: 25px;">
                              <b-img :src='editImageEthOff'/>
                            </div>
                              <i style="margin: 1% 2% 0% 1%">{{ cell.port }}</i>
                            <b-input-group-append >
                              <b-input
                              style="margin-left: 3%;margin-bottom: 1%;height: 25px; width: 65%;"
                              v-model="ipPortIp[cell.port]" @change="ipPortUpdate"></b-input>
                              <i v-if="!ipPortIpComment[cell.port] || ipPortIpComment[cell.port]===''" @click.stop="clickShowComment(cell.port)"
                                style="margin-left: 3%; margin-top:2%"
                                class="primary fa fa-light fa-comment-slash"/>
                              <i v-else @click.stop="clickShowComment(cell.port)"
                              style="margin-left: 3%; margin-top:2%"
                              class="primary fa fa-light fa-comment"/>
                            </b-input-group-append>
                            <b-collapse :visible="ipPortShowComment[cell.port]" class="mt-2">
                              <textarea
                                @change="textValidation"
                                v-model="ipPortIpComment[cell.port]"
                                style="margin-left: 48%;width: 95%;">
                              </textarea>
                            </b-collapse>
                            <div>

                            </div>
                          </b-input-group>
                        </div>
                      </b-form-group>
                    </b-card>
                  </b-collapse>
            </b-tab>

            <b-tab :title="$t('Linked pools')">
              <div>
              <b-form>
                <md-button class="md-raised" @click="showModalPools">{{ $t('Add') }}</md-button>
                <b-table striped hover small
                  :items="poolsItems"
                  :fields="dhcpFIelds">
                  <template v-slot:cell(actions)="row">
                    <i @click.stop="ClickOnDeletePoolButton(row)" class="danger fa fa-trash-alt fa-lg"/>
                </template>
                </b-table>
              </b-form>
              <b-modal hide-footer ref="modalPools"  :title="$t('Pools')">
              <div>
                  <b-table striped hover small selectable select-mode="single" @row-clicked="onRowClicked"
                  :items="dhcpPoolsItems"
                  :fields="dhcpPoolsFields"></b-table>
              </div>
              </b-modal>
              </div>
            </b-tab>

            <b-modal hide-footer ref="MOption125"  :title="$t('Option 125 (Vendor-Specific Information)')">
              <option125 ref="Option125"/>
              <modal-ok-cancel @save="saveOpt125" @cancel="$refs.MOption125.hide()" size="md"/>
            </b-modal>

            <b-tab :title="$t('DHCP options')">
                <div>
                  <b-form>
                    <md-button class="md-raised" @click="showmodalOption">{{ $t('Add') }}</md-button>
                    <md-button class="md-raised" @click="$refs.MOption125.show()" >{{ $t('Add Option 125') }}</md-button>
                    <b-table striped hover small
                      :items="dhcpOptionsList"
                      :fields="dhcpOptionsFields">
                      <template v-slot:cell(actions)="row">
                        <i @click.stop="ClickOnDeleteOptsButton(row)" class="danger fa fa-trash-alt fa-lg"/>
                    </template>
                    <template v-slot:cell(flag)="row">
                        <b-form-checkbox disabled switch size="sm" v-model="row.item.flag"/>
                    </template>
                    </b-table>
                  </b-form>
                  <b-modal hide-footer ref="modalOption"  :title="$t('Option')">
                    <b-form-group label-align="right" :label="$t('Option ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-input @change="optTypeUpd" type="text" v-model="newOpt.option_id"/>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-select  :options="dhcpOptsTypes" type="text" v-model="newOpt.type"/>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-form-input type="text" v-model="newOpt.value"/>
                    </b-form-group>
                    <b-form-group style="margin-top:-2%" label-align="right" :label="$t('Force Add')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                      <b-checkbox switch v-model="newOpt.flag"></b-checkbox>
                    </b-form-group>
                      <modal-ok-cancel @save="optSubmit" @cancel="hidemodalOption" size="md"/>
                  </b-modal>
                </div>
            </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="saveSwitch" @cancel="hideAddSwitch" size="lg"/>
    </b-form>

    <b-modal ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="switch_entry.house_id" @hideFormHouse="hideFormHouse"></FormHouse>
    </b-modal>

    </div>
</template>

<style>
.container {
  display: flex;
  flex-wrap: wrap;
  /* width: 255px; */
  width: 75%;
  margin-top: 10px;
}
.cell {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 25px;
  height: 25px;
  margin-right: -1px;
  margin-bottom: -1px;
}
</style>

<script>
import {calculateSubnetMask, toString} from 'ip-subnet-calculator'

import option125 from '@/components/option125.vue'
import FormHouse from '@/pages/users/usersAndGroups/detail/contacts/formHouse'

export default {
  components: {
    option125,
    FormHouse
  },
  props: {
    isEdit: false,
    currentRowSwitch: null
  },
  data () {
    return {
      deleteImage: require('@/assets/img/document_delete.png'),
      editImageEthOff: require('@/assets/img/ethernet_off.png'),
      editImageEthOn: require('@/assets/img/ethernet_on.png'),
      editImageEthError: require('@/assets/img/ethernet_error.png'),
      switchIpPortBinding: {},
      rerenderPorts: 0,
      ipPortShowComment: [],
      ipPortIpComment: [],
      ipPortIpEnable: [],
      ipPortIp: [],
      ipPortSubnet: '',
      portUsageLength: 0,
      portsUsedVar: 0,
      portsCountMap: new Map(),
      portsUsageMap: new Map(),
      linkedPoolsArr: [],
      isOptsModifiedFlag: false,
      isPoolLinkedFlag: false,
      cellsDATA: [],
      dhcpPoolsItems: [],
      dhcpPoolsFields: [
        {key: 'id', label: this.$i18n.t('Pool ID'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true}
      ],
      poolsItems: [],
      dhcpFIelds: [
        {key: 'pool_id', label: this.$i18n.t('Pool ID'), sortable: true},
        {key: 'gateway', label: this.$i18n.t('Gateway'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      dhcpOptionsList: [],
      dhcpOptionsFields: [
        {key: 'option_id', label: this.$i18n.t('Option ID'), sortable: true},
        {key: 'type', label: this.$i18n.t('Type'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'flag', label: this.$i18n.t('Force Add'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      switch_entry: {
        'address': '',
        'id': 0,
        'location': '',
        'house_id': 0,
        'login': '',
        'name': '',
        'password': '',
        'ports_count': '',
        'remote_id': '',
        'type': 1,
        'dhcp_pools': []
      },
      dhcpPoolLink: {
        'switch_id': 0,
        'links': []
      },
      dhcpOptionPut: {
        'owner_id': 0,
        'type': 1,
        'options': []
      },
      newOpt: {
        'option_id': '',
        'type': '',
        'value': ''
      },
      emptyOpt: {
        'option_id': '',
        'type': '',
        'value': ''
      },
      portUsageArr: null,
      dhcpOptsTypeMap: new Map([
        [1, this.$i18n.t('Number')],
        [2, this.$i18n.t('String')],
        [3, this.$i18n.t('IP address')],
        [4, this.$i18n.t('Binary')],
        [5, this.$i18n.t('IP address array')]
      ]),
      dhcpOptsTypeReverseMap: new Map([
        [this.$i18n.t('Number'), 1],
        [this.$i18n.t('String'), 2],
        [this.$i18n.t('IP address'), 3],
        [this.$i18n.t('Binary'), 4],
        [this.$i18n.t('IP address array'), 5]
      ]),
      dhcpOptsTypes: [this.$i18n.t('Number'), this.$i18n.t('String'),
        this.$i18n.t('IP address'), this.$i18n.t('Binary'), this.$i18n.t('IP address array')],
      dhcpOptsKnownId: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
        38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54,
        55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
        72, 73, 74, 75, 76, 77, 81, 82, 85, 86, 87, 118, 121, 122, 128, 185, 220, 221, 251],
      dhcpOptsIdMap: new Map([
        [1, ['1 (subnet-mask (derived))', 3]],
        [2, ['2 (time-offset)', 1]],
        [3, ['3 (routers)', 5]],
        [4, ['4 (time-servers)', 5]],
        [5, ['5 (name-servers)', 5]],
        [6, ['6 (domain-name-servers)', 5]],
        [7, ['7 (log-servers)', 5]],
        [8, ['8 (cookie-servers)', 5]],
        [9, ['9 (lpr-servers)', 5]],
        [10, ['10 (impress-servers)', 5]],
        [11, ['11 (resource-location-servers)', 5]],
        [12, ['12 (host-name)', 2]],
        [13, ['13 (boot-size)', 4]],
        [14, ['14 (merit-dump)', 2]],
        [15, ['15 (domain-name)', 2]],
        [16, ['16 (swap-server)', 3]],
        [17, ['17 (root-path)', 2]],
        [18, ['18 (extensions-path)', 2]],
        [19, ['19 (ip-forwarding)', 1]],
        [20, ['20 (non-local-source-routing)', 1]],
        [21, ['21 (policy-filters)', 5]],
        [22, ['22 (max-dgram-reassembly)', 4]],
        [23, ['23 (default-ip-ttl)', 4]],
        [24, ['24 (path-mtu-aging-timeout)', 1]],
        [25, ['25 (path-mtu-plateau-tables)', 4]],
        [26, ['26 (interface-mtu)', 4]],
        [27, ['27 (all-subnets-local)', 1]],
        [28, ['28 (broadcast-address)', 3]],
        [29, ['29 (perform-mask-discovery)', 1]],
        [30, ['30 (mask-supplier)', 1]],
        [31, ['31 (router-discovery)', 1]],
        [32, ['32 (router-solicitation-address)', 3]],
        [33, ['33 (static-routes)', 5]],
        [34, ['34 (trailer-encapsulation)', 1]],
        [35, ['35 (arp-cache-timeout)', 1]],
        [36, ['36 (ieee802.3-encapsulation)', 1]],
        [37, ['37 (default-tcp-ttl)', 4]],
        [38, ['38 (tcp-keepalive-interval)', 1]],
        [39, ['39 (tcp-keepalive-garbage)', 1]],
        [40, ['40 (nis-domain)', 2]],
        [41, ['41 (nis-servers)', 5]],
        [42, ['42 (ntp-servers)', 5]],
        [43, ['43 (vendor-encapsulated-options)', 4]],
        [44, ['44 (netbios-name-servers)', 5]],
        [45, ['45 (netbios-dd-servers)', 5]],
        [46, ['46 (netbios-node-type)', 4]],
        [47, ['47 (netbios-scope)', 2]],
        [48, ['48 (font-servers)', 5]],
        [49, ['49 (x-display-managers)', 5]],
        [50, ['50 (dhcp-requested-address (set by DHCP client))', 3]],
        [51, ['51 (dhcp-lease-time)', 1]],
        [52, ['52 (dhcp-option-overload)', 4]],
        [53, ['53 (dhcp-message-type (set by protocols))', 4]],
        [54, ['54 (dhcp-server-identifier (set by DHCP server))', 3]],
        [55, ['55 (dhcp-parameter-request-list)', 4]],
        [56, ['56 (dhcp-message)', 2]],
        [57, ['57 (dhcp-max-message-size (set by protocol))', 4]],
        [58, ['58 (dhcp-renewal-time)', 1]],
        [59, ['59 (dhcp-rebinding-time)', 1]],
        [60, ['60 (dhcp-class-identifier (set by DHCP client))', 2]],
        [61, ['61 (dhcp-client-identifier (set by DHCP client))', 4]],
        [62, ['62 (netwareip-domain)', 2]],
        [63, ['63 (netwareip-information)', 4]],
        [64, ['64 (nis+-domain)', 2]],
        [65, ['65 (nis+-servers)', 5]],
        [66, ['66 (tftp-server)', 2]],
        [67, ['67 (boot-file)', 2]],
        [68, ['68 (mobile-ip-home-agents)', 5]],
        [69, ['69 (smtp-servers)', 5]],
        [70, ['70 (pop3-servers)', 5]],
        [71, ['71 (nntp-servers)', 5]],
        [72, ['72 (www-servers)', 5]],
        [73, ['73 (finger-servers)', 5]],
        [74, ['74 (irc-servers)', 5]],
        [75, ['75 (streettalk-servers)', 5]],
        [76, ['76 (streettalk-directory-assistance-servers)', 5]],
        [77, ['77 (dhcp-user-class-id (set by DHCP client))', 2]],
        [81, ['81 (client-fqdn)', 4]],
        [82, ['82 (relay-agent-info)', 4]],
        [85, ['85 (nds-servers)', 5]],
        [86, ['86 (nds-tree)', 2]],
        [87, ['87 (nds-context)', 2]],
        [118, ['118 (subnet-selection)', 3]],
        [121, ['121 (classless-route)', 3]],
        [122, ['122 (cablelabs-client-configuration)', 4]],
        [128, ['128 (mcns-security-server)', 3]],
        [185, ['185 (vpn-id)', 4]],
        [220, ['220 (cisco-subnet-allocation)', 4]],
        [221, ['221 (cisco-vpn-id)', 4]],
        [251, ['251 (auto-configure)', 4]]
      ]),
      dhcpOptsIdReverseMap: new Map([
        ['1 (subnet-mask (derived))', 1],
        ['2 (time-offset)', 2],
        ['3 (routers)', 3],
        ['4 (time-servers)', 4],
        ['5 (name-servers)', 5],
        ['6 (domain-name-servers)', 6],
        ['7 (log-servers)', 7],
        ['8 (cookie-servers)', 8],
        ['9 (lpr-servers)', 9],
        ['10 (impress-servers)', 10],
        ['11 (resource-location-servers)', 11],
        ['12 (host-name)', 12],
        ['13 (boot-size)', 13],
        ['14 (merit-dump)', 14],
        ['15 (domain-name)', 15],
        ['16 (swap-server)', 16],
        ['17 (root-path)', 17],
        ['18 (extensions-path)', 18],
        ['19 (ip-forwarding)', 19],
        ['20 (non-local-source-routing)', 20],
        ['21 (policy-filters)', 21],
        ['22 (max-dgram-reassembly)', 22],
        ['23 (default-ip-ttl)', 23],
        ['24 (path-mtu-aging-timeout)', 24],
        ['25 (path-mtu-plateau-tables)', 25],
        ['26 (interface-mtu)', 26],
        ['27 (all-subnets-local)', 27],
        ['28 (broadcast-address)', 28],
        ['29 (perform-mask-discovery)', 29],
        ['30 (mask-supplier)', 30],
        ['31 (router-discovery)', 31],
        ['32 (router-solicitation-address)', 32],
        ['33 (static-routes)', 33],
        ['34 (trailer-encapsulation)', 34],
        ['35 (arp-cache-timeout)', 35],
        ['36 (ieee802.3-encapsulation)', 36],
        ['37 (default-tcp-ttl)', 37],
        ['38 (tcp-keepalive-interval)', 38],
        ['39 (tcp-keepalive-garbage)', 39],
        ['40 (nis-domain)', 40],
        ['41 (nis-servers)', 41],
        ['42 (ntp-servers)', 42],
        ['43 (vendor-encapsulated-options)', 43],
        ['44 (netbios-name-servers)', 44],
        ['45 (netbios-dd-servers)', 45],
        ['46 (netbios-node-type)', 46],
        ['47 (netbios-scope)', 47],
        ['48 (font-servers)', 48],
        ['49 (x-display-managers)', 49],
        ['50 (dhcp-requested-address (set by DHCP client))', 50],
        ['51 (dhcp-lease-time)', 51],
        ['52 (dhcp-option-overload)', 52],
        ['53 (dhcp-message-type (set by protocols))', 53],
        ['54 (dhcp-server-identifier (set by DHCP server))', 54],
        ['55 (dhcp-parameter-request-list)', 55],
        ['56 (dhcp-message)', 56],
        ['57 (dhcp-max-message-size (set by protocol))', 57],
        ['58 (dhcp-renewal-time)', 58],
        ['59 (dhcp-rebinding-time)', 59],
        ['60 (dhcp-class-identifier (set by DHCP client))', 60],
        ['61 (dhcp-client-identifier (set by DHCP client))', 61],
        ['62 (netwareip-domain)', 62],
        ['63 (netwareip-information)', 63],
        ['64 (nis+-domain)', 64],
        ['65 (nis+-servers)', 65],
        ['66 (tftp-server)', 66],
        ['67 (boot-file)', 67],
        ['68 (mobile-ip-home-agents)', 68],
        ['69 (smtp-servers)', 69],
        ['70 (pop3-servers)', 70],
        ['71 (nntp-servers)', 71],
        ['72 (www-servers)', 72],
        ['73 (finger-servers)', 73],
        ['74 (irc-servers)', 74],
        ['75 (streettalk-servers)', 75],
        ['76 (streettalk-directory-assistance-servers)', 76],
        ['77 (dhcp-user-class-id (set by DHCP client))', 77],
        ['81 (client-fqdn)', 81],
        ['82 (relay-agent-info)', 82],
        ['85 (nds-servers)', 85],
        ['86 (nds-tree)', 86],
        ['87 (nds-context)', 87],
        ['118 (subnet-selection)', 118],
        ['121 (classless-route)', 121],
        ['122 (cablelabs-client-configuration)', 122],
        ['128 (mcns-security-server)', 128],
        ['185 (vpn-id)', 185],
        ['220 (cisco-subnet-allocation)', 220],
        ['221 (cisco-vpn-id)', 221],
        ['251 (auto-configure)', 251]
      ]),
      dhcpOptsKnownIdname: ['1 (subnet-mask (derived))', '2 (time-offset)', '3 (routers)', '4 (time-servers)',
        '5 (name-servers)', '6 (domain-name-servers)', '7 (log-servers)', '8 (cookie-servers)', '9 (lpr-servers)',
        '10 (impress-servers)', '11 (resource-location-servers)', '12 (host-name)', '13 (boot-size)', '14 (merit-dump)',
        '15 (domain-name)', '16 (swap-server)', '17 (root-path)', '18 (extensions-path)', '19 (ip-forwarding)',
        '20 (non-local-source-routing)', '21 (policy-filters)', '22 (max-dgram-reassembly)', '23 (default-ip-ttl)',
        '24 (path-mtu-aging-timeout)', '25 (path-mtu-plateau-tables)', '26 (interface-mtu)', '27 (all-subnets-local)',
        '28 (broadcast-address)', '29 (perform-mask-discovery)', '30 (mask-supplier)', '31 (router-discovery)',
        '32 (router-solicitation-address)', '33 (static-routes)', '34 (trailer-encapsulation)', '35 (arp-cache-timeout)',
        '36 (ieee802.3-encapsulation)', '37 (default-tcp-ttl)', '38 (tcp-keepalive-interval)', '39 (tcp-keepalive-garbage)',
        '40 (nis-domain)', '41 (nis-servers)', '42 (ntp-servers)', '43 (vendor-encapsulated-options)', '44 (netbios-name-servers)',
        '45 (netbios-dd-servers)', '46 (netbios-node-type)', '47 (netbios-scope)', '48 (font-servers)', '49 (x-display-managers)',
        '50 (dhcp-requested-address (set by DHCP client))', '51 (dhcp-lease-time)', '52 (dhcp-option-overload)',
        '53 (dhcp-message-type (set by protocols))', '54 (dhcp-server-identifier (set by DHCP server))', '55 (dhcp-parameter-request-list)',
        '56 (dhcp-message)', '57 (dhcp-max-message-size (set by protocol))', '58 (dhcp-renewal-time)', '59 (dhcp-rebinding-time)',
        '60 (dhcp-class-identifier (set by DHCP client))', '61 (dhcp-client-identifier (set by DHCP client))', '62 (netwareip-domain)',
        '63 (netwareip-information)', '64 (nis+-domain)', '65 (nis+-servers)', '66 (tftp-server)', '67 (boot-file)',
        '68 (mobile-ip-home-agents)', '69 (smtp-servers)', '70 (pop3-servers)', '71 (nntp-servers)', '72 (www-servers)',
        '73 (finger-servers)', '74 (irc-servers)', '75 (streettalk-servers)', '76 (streettalk-directory-assistance-servers)',
        '77 (dhcp-user-class-id (set by DHCP client))', '81 (client-fqdn)', '82 (relay-agent-info)', '85 (nds-servers)',
        '86 (nds-tree)', '87 (nds-context)', '118 (subnet-selection)', '121 (classless-route)', '122 (cablelabs-client-configuration)',
        '128 (mcns-security-server)', '185 (vpn-id)', '220 (cisco-subnet-allocation)', '221 (cisco-vpn-id)', '251 (auto-configure)'],
      opts125: []
    }
  },
  methods: {
    textValidation (val) {
      if (val.target._value.length > 255) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('max len of comment = 255 chars'), 'Error')
      }
    },
    clickShowComment (port) {
      this.ipPortShowComment[port] = !this.ipPortShowComment[port]
      ++this.rerenderPorts
    },
    ipPortUpdate (val) {
      let subnet = val.split('/')
      let net = subnet[0]
      let mask = subnet[1]
      if (mask < 0 || mask > 32) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('ip subnet format = 192.168.1.0/24'), 'Error')
        return
      }
      let ip = calculateSubnetMask(net, mask)
      if (!ip) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('ip subnet format = 192.168.1.0/24'), 'Error')
      }
    },
    ipPortSubnetUpdate (val) {
      let subnet = val.split('/')
      let net = subnet[0]
      let mask = subnet[1]
      if (mask < 0 || mask > 32) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('ip subnet format = 192.168.1.0/24'), 'Error')
        return
      }
      let ip = calculateSubnetMask(net, mask)
      if (!ip) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('ip subnet format = 192.168.1.0/24'), 'Error')
        return
      }
      this.ipPortSubnet = ip.ipLowStr + '/' + subnet[1]
      let iterIp = ip.ipLow
      for (let d of this.cellsDATA) {
        if (!this.ipPortIpEnable[d.port]) {
          continue
        }
        iterIp = iterIp + 1
        this.ipPortIp[d.port] = toString(iterIp) + '/' + mask
      }
      ++this.rerenderPorts
    },
    showFormHouse () {
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.$refs.houseUser.hide()
    },
    saveOpt125 () {
      let opt125 = this.$refs.Option125.getOption125()
      this.dhcpOptionsList.push(opt125.optEl)
      this.opts125.push(opt125.opt125)
      this.isOptsModifiedFlag = true
      this.$refs.MOption125.hide()
    },
    optTypeUpd () {
      if (this.dhcpOptsKnownId.includes(Number(this.newOpt.option_id))) {
        this.newOpt.type = this.dhcpOptsTypeMap.get(this.dhcpOptsIdMap.get(Number(this.newOpt.option_id))[1])
        this.newOpt.option_id = this.dhcpOptsIdMap.get(Number(this.newOpt.option_id))[0]
      }
    },
    ClickOnDeletePoolButton (row) {
      this.isPoolLinkedFlag = true
      this.selectSubnet = row.item
      this.poolsItems = this.poolsItems.filter((value) => {
        return value !== this.selectSubnet
      })
      this.dhcpPoolLink.links = this.dhcpPoolLink.links.filter((value) => {
        return value.id !== this.selectSubnet.pool_id
      })
    },
    ClickOnDeleteOptsButton (row) {
      this.selectSubnet = row.item
      this.dhcpOptionsList = this.dhcpOptionsList.filter((value) => {
        return (value.option_id + value.value) !== (this.selectSubnet.option_id + this.selectSubnet.value)
      })
      this.opts125 = this.opts125.filter((value) => {
        return value.prepared_val !== this.selectSubnet.value
      })
      this.isOptsModifiedFlag = true
    },
    showModalPools () {
      this.$refs.modalPools.show()
    },
    showmodalOption () {
      this.newOpt = JSON.parse(JSON.stringify(this.emptyOpt))
      this.$refs.modalOption.show()
    },
    onRowClicked (row) {
      let tmpIt = { pool_id: row.id, gateway: row.name }
      this.poolsItems.push(tmpIt)
      let tmpItPut = { id: row.id }
      this.addDHCPPool(tmpItPut)
      this.hidemodalPools()
    },
    optSubmit () {
      let tmpOpt = JSON.parse(JSON.stringify(this.newOpt))
      this.dhcpOptionsList.push(tmpOpt)
      this.newOpt = JSON.parse(JSON.stringify(this.emptyOpt))
      this.isOptsModifiedFlag = true
      this.hidemodalOption()
    },
    hidemodalPools () {
      this.$refs.modalPools.hide()
    },
    hidemodalOption () {
      this.$refs.modalOption.hide()
    },
    async getDHCPPools () {
      await this.$store.dispatch('Inventory/GET_DHCP_POOLS').then(response => {
        let tmpDHCPpools = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_POOLS']))
        for (let pool of tmpDHCPpools) {
          let tmpPool = { id: pool.id, name: (pool.gateway + '/' + pool.netmask) }
          this.dhcpPoolsItems.push(tmpPool)
        }
      })
    },
    subOpt125Parser (val) {
      let res = '\n SubOptID: ' + parseInt(val.slice(0, 2), 16)
      res = res + ' SubOptLength: ' + parseInt(val.slice(2, 4), 16)
      res = res + ' SubOptString: ' + this.hex_to_ascii(val.slice(4)) + ' (hex:' + val.slice(4) + ')'
      return res
    },
    hex_to_ascii (str1) {
      var hex = str1.toString()
      var str = ''
      for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16))
      }
      return str
    },
    parseOpt125Value (val, flag_) {
      let res = 'Enterprise : '
      let EnterpriseID = val.slice(0, 8)
      res = res + parseInt(EnterpriseID, 16)
      let l = val.slice(8, 10)
      res = res + ' Length: ' + parseInt(l, 16)
      let currentIndx = 0
      let subOpts = val.slice(10)
      while (subOpts.length > 0) {
        let SOptLen = parseInt(subOpts.slice(2, 4), 16)
        if (isNaN(SOptLen)) {
          break
        }
        let dataLen = 2 * Number(SOptLen)
        let idAndL = 2 + 2 // id = 1 byte(2 character)  Length = 1 byte
        currentIndx = dataLen + idAndL
        res = res + this.subOpt125Parser(subOpts.slice(0, currentIndx))
        subOpts = subOpts.slice(currentIndx)
      }
      let opt = {option_id: 125, type: 4, value: val, flag: flag_, prepared_val: res}
      this.opts125.push(opt)
      return opt
    },
    async getDHCPOptions () {
      let payload = {
        type: 1,
        id: 0
      }
      payload.id = this.switch_entry.id
      let tmpArr = []
      await this.$store.dispatch('Inventory/GET_DHCP_OPTIONS', payload).then(response => {
        tmpArr = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_OPTIONS']))
      })
      tmpArr.forEach(element => {
        if (this.dhcpOptsKnownId.includes(element.option_id)) {
          this.dhcpOptionsList.push(
            {
              option_id: this.dhcpOptsIdMap.get(element.option_id)[0],
              type: this.dhcpOptsTypeMap.get(element.data_type),
              value: element.data,
              flag: element.flag === 1
            }
          )
        } else {
          if (element.option_id !== 125) {
            this.dhcpOptionsList.push(
              {
                option_id: element.option_id,
                type: this.dhcpOptsTypeMap.get(element.data_type),
                value: element.data,
                flag: element.flag === 1
              })
          } else {
            this.dhcpOptionsList.push(
              {
                option_id: element.option_id,
                type: this.dhcpOptsTypeMap.get(element.data_type),
                value: this.parseOpt125Value(element.data, element.flag).prepared_val,
                flag: element.flag === 1
              })
          }
        }
      })
    },
    addDHCPPool (it) {
      this.isPoolLinkedFlag = true
      this.dhcpPoolLink.links.push(it)
    },
    hideAddSwitch () {
      this.$emit('hideAddSwitch')
    },
    setLinkedList (addedSwID) {
      this.dhcpPoolLink.switch_id = Number(addedSwID)
      let response = this.$store.dispatch('Inventory/UPDATE_DHCP_POOL_LINKS', this.dhcpPoolLink)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Pools linked to switch'))
        }
      })
    },
    setSwitchOpts (addedSwID) {
      this.dhcpOptionPut.owner_id = Number(addedSwID)

      for (let element of this.dhcpOptionsList) {
        if (this.dhcpOptsKnownIdname.includes(element.option_id)) {
          let tmpOpt = element.option_id
          element.option_id = this.dhcpOptsIdReverseMap.get(tmpOpt)
        } else { element.option_id = Number(element.option_id) }
        let tmpType = element.type
        element.type = this.dhcpOptsTypeReverseMap.get(tmpType)
        let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
        if (element.type === 1) {
          element.value = Number(element.value)
        } else if (element.type === 2) {
          element.value = String(element.value)
        } else if (element.type === 3) {
          element.value = String(element.value)
          if (element.value.match(goodChars)) { continue } else {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address has failed format'), 'Error')
          }
        } else if (element.type === 4) {
          element.value = String(element.value)
        } else if (element.type === 5) {
          element.value = String(element.value).split(/[,;]/)
          for (let ip of element.value) {
            if (ip.match(goodChars)) { continue } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Ip address has failed format'), 'Error')
            }
          }
        }
      }

      let hasOpt125 = false
      this.dhcpOptionsList.forEach(element => {
        if (element.option_id === 125) {
          hasOpt125 = true
        } else {
          this.dhcpOptionPut.options.push(
            {id: element.option_id,
              data_type: element.type,
              data_value: element.value,
              flag: element.flag ? 1 : 0 })
        }
      })
      if (hasOpt125) {
        this.opts125.forEach(el => {
          this.dhcpOptionPut.options.push(
            {id: 125,
              data_type: 4,
              data_value: el.value,
              flag: el.flag ? 1 : 0 })
        })
      }

      let response = this.$store.dispatch('Inventory/CREATE_DHCP_OPTIONS', this.dhcpOptionPut)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Options added to switch'))
        }
      })
    },
    storeIpPortBinding () {
      let payload = {bindings: []}
      if (this.ipPortIp.length === 0) {
        return
      }
      for (let port in this.ipPortIp) {
        let ip = this.ipPortIp[port].split('/')
        if (ip.length !== 2) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('failed format ip/mask'), 'Error')
          continue
        }
        if (this.ipPortIp[port]) {
          payload.bindings.push({
            switch_id: this.switch_entry.switch_id,
            port: Number(port),
            ip: ip[0],
            mask: ip[1],
            enable: this.ipPortIpEnable[port],
            comment: this.ipPortIpComment[port]
          })
        }
      }
      this.$store.dispatch('Inventory/CREATE_SWITCHES_BINDING', payload).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t(response.data.error), 'Error')
        } else {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Switch binding added'))
        }
      })
    },
    async getPoolsData () {
      await this.$store.dispatch('Inventory/GET_DHCP_POOL_LINKS', this.switch_entry.id).then(response => {
        let tmpPoolsData = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_POOL_LINKS']))
        this.poolsItems = tmpPoolsData.map(function (item) {
          return {pool_id: item.id,
            gateway: (item.gateway + '/' + item.netmask) }
        })
      })
    },
    saveSwitch () {
      this.switch_entry.ports_count = Number(this.switch_entry.ports_count)
      if (this.switch_entry.type !== 1 && !this.switch_entry.remote_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Please assign Remote ID', 'Error'))
        return
      }
      if (this.switch_entry.ports_count === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Please select ports count of profile', 'Error'))
        return
      }
      if (this.isEdit) {
        this.$store.dispatch('Inventory/UPDATE_SWITCHES', this.switch_entry).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts', 'success', this.$i18n.t('Switch updated'))
            if (this.isPoolLinkedFlag) this.setLinkedList(this.switch_entry.id)
            if (this.isOptsModifiedFlag) {
              let payload = {
                type: 1,
                id: 0
              }
              payload.id = this.switch_entry.id
              let response = this.$store.dispatch('Inventory/DELETE_DHCP_OPTIONS', payload)
              response.then(response => {
                if (response.data.error) {
                  this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
                } else {
                  this.setSwitchOpts(this.switch_entry.id)
                  this.$root.$emit('makeToasts', 'success', this.$i18n.t('Pools linked to switch'))
                }
              })
            }
            setTimeout(this.$store.dispatch, 500, 'Inventory/GET_SWITCHES_PAGED', {page: 1, filter: '', perPage: 20})
            this.storeIpPortBinding()
            this.hideAddSwitch()
          }
        })
      } else {
        this.$store.dispatch('Inventory/CREATE_SWITCHES', this.switch_entry).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts', 'success', this.$i18n.t('Switch added'))
            if (this.isPoolLinkedFlag) this.setLinkedList(response.data.switch_id)
            if (this.isOptsModifiedFlag) this.setSwitchOpts(response.data.switch_id)
          }
        })
        setTimeout(this.$store.dispatch, 500, 'Inventory/GET_SWITCHES_PAGED', {page: 1, filter: '', perPage: 20})
        this.storeIpPortBinding()
        this.hideAddSwitch()
      }
    },
    updSwEntryReact () {
      this.switch_entry = JSON.parse(JSON.stringify(this.switch_entry))
    },
    load () {
      if (this.isEdit) {
        this.getDHCPOptions()
        this.portUsageLength = this.portUsageArr.length
      } else {
        setTimeout(this.updSwEntryReact, 1500)
      }
      if (this.switch_entry.dhcp_pools.length > 0) {
        this.getPoolsData()
        this.linkedPoolsArr = this.switch_entry.dhcp_pools.map(function (currentValue) {
          return { pool_id: currentValue, gateway: '' }
        })
        for (let item of this.switch_entry.dhcp_pools) {
          this.dhcpPoolLink.links.push({id: item})
        }
      }
    }
  },
  computed: {
    registrySettings () {
      return JSON.parse(JSON.stringify(this.$store.getters['Settings/REGISTRY_SETTINGS']))
    },
    isEnabledIpPortLink () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'set_ipgroup_static_ip_by_switch_ip_port'
      })
      return tmp.length ? tmp[0].raw_values[0].value === '1' : null
    },
    portsCountOpt: function () {
      let tmp = this.portsCountMap.get(this.switch_entry.type)
      return tmp
    },
    houseOptions () {
      const opts = JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/BUILDINGS']))
      return opts.map(el => {
        return {value: el.house_id, text: el.city + '; ' + el.street + '; ' + el.number + '; ' + el.building}
      })
    },
    switchProfiles () {
      let tmpSwitchProfiles = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCH_TYPES']))
      let _SwitchProfiles = []
      for (let profile of tmpSwitchProfiles) {
        let switchProfileEntry = { value: '', text: '' }
        switchProfileEntry.text = profile.name
        switchProfileEntry.value = profile.id
        this.portsCountMap.set(profile.id, profile.supp_volumes.split(','))
        _SwitchProfiles.push(switchProfileEntry)
      }
      return _SwitchProfiles
    }
  },
  async mounted  () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 7, object_id: 0})
    this.getDHCPPools()
    this.$store.dispatch('ReferenceBooks/GET_BUILDINGS')
    if (this.isEdit) {
      await this.$store.dispatch('Inventory/GET_SWITCH_IP_PORT_BINDING', this.currentRowSwitch.switch_id).then(response => {
        this.switchIpPortBinding = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCH_BINDING']))
        for (let binding of this.switchIpPortBinding.bindings) {
          this.ipPortIp[binding.port] = binding.ip_address
          this.ipPortIpEnable[binding.port] = binding.enable
          this.ipPortIpComment[binding.port] = binding.comment
          this.ipPortShowComment[binding.port] = false
        }
      })
      await this.$store.dispatch('Inventory/GET_SWITCHE_PORTS_USAGE', this.currentRowSwitch.switch_id).then(response => {
        this.portUsageArr = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCHE_PORTS_USAGE']))
      })

      this.switch_entry = JSON.parse(JSON.stringify(this.currentRowSwitch))
      this.portsUsedVar = this.switch_entry.ports_count - this.portUsageArr.length
      let cellsMap = {}
      this.portsUsageMap = new Map()
      let port = 0
      let portsCount = this.switch_entry.ports_count
      if (this.switch_entry.ports_num_offset === 1) {
        port = 1
        portsCount += 1
      }

      for (port; port < portsCount; ++port) {
        cellsMap[port] = {id: port, port: port, isOn: false}
        this.portsUsageMap.set(port, JSON.stringify({port: port}))
      }

      for (let el of this.portUsageArr) {
        let port = el.port
        this.portsUsageMap.set(port, JSON.stringify({user_data: el.user_data, port: port}))
        if (cellsMap[port]) {
          cellsMap[port].isOn = true
        }
      }
      for (let key in cellsMap) {
        this.cellsDATA.push(cellsMap[key])
      }
    }

    if (this.ipPortIpEnable.length === 0) {
      for (let el of this.cellsDATA) {
        this.ipPortIpEnable[el.port] = true
        this.ipPortIpComment[el.port] = ''
      }
    }
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/switches/formAdd.vue